import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {HgImportDto} from "../../../model/dto/entity/hg-import.dto";

/**
 * HgImport ObjectBaseComponent dispatcher.
 *
 * Renders the full or side view depending on the current uiMode input.
 * Read-only — no edit mode is supported on this OBC.
 */
@Component({
    selector: 'hg-import-object-component',
    templateUrl: 'hg-import-object.component.html',
    standalone: false
})
export class HgImportObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    override dto: HgImportDto;

    /**
     * On Object Change.
     */
    onObjectChanged() {
        if (this.dto) {
            this.handleName(this.dto.hgPartnerDtoName || 'GDV Import');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
